import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import React from "react";

export const LegalFooter = () => (
	<div
		style={{
			position: "sticky",
			bottom: 0,
			left: 0,
			right: 0,
			zIndex: 100,
			padding: 16,
			display: "flex",
			background: "white",
			justifyContent: "space-between",
		}}
	>
		<Container>
			<Link href="/#/legal/cookies">Cookieeinstellungen</Link>{" "}
			<Link
				target="_blank"
				href="https://www.easycheck-by-edding.com/impressum/"
				rel="noreferrer"
			>
				Impressum
			</Link>{" "}
			<Link
				target="_blank"
				href="https://www.easycheck-by-edding.com/datenschutzerklaerung-manager/"
				rel="noreferrer"
			>
				Datenschutzerklärung
			</Link>
		</Container>
	</div>
);
